import { defaultApi } from "@/config/httpClient";
import { getLanguageHeaders } from "@/config/i18n";
import {
  CreateLegalEntityDto,
  LegalEntityDto,
  ObjectStatus,
  RegionType,
  ResultLegalEntityDto
} from "@/generated/openapi";
import { OnbTableSortOptions } from "@/models/OnbTableColumnDefinition";
import { asSortString } from "@/utils/apiUtils";

class LegalEntityService {

  public getLegalEntitiesByAdmin(limit: number, offset: number, area?: string, region?: RegionType, status?: ObjectStatus, locationFulltext?: string, searchTerm?: string, sortOptions?: OnbTableSortOptions, name?: string ): Promise<ResultLegalEntityDto> {
    const sortString = asSortString(sortOptions)
    return defaultApi.findLegalEntitiesByAdmin(searchTerm, undefined, area, region, status, locationFulltext, name, limit, offset, sortString).then(response => {
      if (response.data) {
        return response.data
      }
      return {} as ResultLegalEntityDto
    }).catch((err) => {
      throw err;
    });
  }

  public createLegalEntity(legEnt: CreateLegalEntityDto): Promise<LegalEntityDto> {
    return defaultApi.createLegalEntityByAdmin(legEnt).then(resp => {
      return resp.data
    }).catch(err => {
      throw err;
    })
  }

  public updateLegalEntity(legEnt: LegalEntityDto): Promise<LegalEntityDto> {
    return defaultApi.updateLegalEntityByAdmin(`${legEnt.id}`, legEnt).then(resp => {
      return resp.data
    }).catch(err => {
      throw err;
    })
  }

  public getLegalEntity(id: string): Promise<LegalEntityDto> {
    return defaultApi.getLegalEntity(id, getLanguageHeaders()).then((resp) => {
      return resp.data
    }).catch((err) => {
      throw err;
    });
  }

  /**
   * Diese Methode ist nur für die Verwaltungsapplikation gedacht
   * @param id
   * @returns
   */
  public getLegalEntityByAdmin(id: string): Promise<LegalEntityDto> {
    return defaultApi.getLegalEntityByAdmin(id, getLanguageHeaders()).then((resp) => {
      return resp.data
    }).catch((err) => {
      throw err;
    });
  }

  public deleteLegalEntity(id: string): Promise<void> {
    return defaultApi.deleteLegalEntityByAdmin(id).then((_) => {
      return
    }).catch(err => {
      throw err;
    })
  }

}




const legalEntityService = new LegalEntityService()
export default legalEntityService
